import { useSelector, useDispatch } from 'react-redux';
import { fetchUserAuthenticationInfo } from 'modules/labs/accountManagement/actions';
import LoginContainer from 'modules/shared/accountManagement/containers/LoginContainer';
import accountManagementStrings from 'modules/labs/accountManagement/strings';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const LoginView = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const userAuthenticationInfo = useSelector(
    state => state.accountManagement.userAuthenticationInfo,
  );

  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const submitUserLoginData = (username, password) => {
    const body = {
      data: {
        username,
        password,
      },
    };
    dispatch(fetchUserAuthenticationInfo(body));
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <LoginContainer
      stringsData={accountManagementStrings}
      userAuthenticationInfo={userAuthenticationInfo}
      submitUserLoginData={submitUserLoginData}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

LoginView.propTypes = {};

LoginView.defaultProps = {};

export default LoginView;
